const assetRouter = [
	{
		path: '/asset',
		children: [
			{
				path: '',
				name: 'Asset',
				redirect: '/asset/schema',
			},
			{
				path: 'schema',
				name: 'Schema',
				component: () => import('../template/BasicTemplate.vue'),
			},
			{
				path: 'dropbox',
				name: 'Dropbox',
				component: () => import('../template/BasicTemplate.vue'),
			},
		],
		component: () => import('../template/BasicTemplate.vue'),
	},
]

export default assetRouter
